// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bz-0";
export var orangeButton = "_bz-1";